import React, { useEffect, useState } from "react";
import Button from "../../../components/Buttons/Button";
import DataTable from "../../../components/DataTable/DataTable";
import { IColInfo } from "../../../components/DataTable/Interfaces";
import TextboxField from "../../../components/Fields/TextboxField";
import { FormConfig } from "../../../components/Fields/Types";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import SpinnerOverlay from "../../../components/Spinner/SpinnerOverlay";
import { useNotifications } from "../../../contexts/notificationContext";
import WorkflowModel from "../../../models/WorkflowModel";
import DataService from "../../../services/data.service";
import { ProjectPopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";

interface WorkflowChangeStatusModel {
    workflowIds: number[]
    reason: string
}

const StopItemWorkflowsPopup: React.FC<ProjectPopupProps> = ({ show, onHide, projectId, projectTypeId }) => {
    const [formData, setFormData] = useState<WorkflowChangeStatusModel>();
    const [tableData, setTableData] = useState<WorkflowModel[]>([])
    const [itemStatusTypes, setItemStatusTypes] = useState<string[]>()
    const [showSpinner, setShowSpinner] = useState(false)
    const { handleResult, handleException } = useNotifications();

    useEffect(() => {
        const defaultFormData = {
            workflowIds: [],
            reason: ''
        }

        setFormData(defaultFormData);
    }, [show]);

    useEffect(() => {
        DataService
            .get<WorkflowModel[]>(`api/v1/ProjectItemRevisions/ActiveWorkflows?projectId=${projectId}`)
            .then(response => {
                let statusTypes: string[] = []
                response.forEach(x => {
                    x.itemRevision.itemRevisionStatuses.forEach(y => {
                        if (y.isLatest && statusTypes.includes(y.itemStatus.itemStatusType.name) == false) {
                            statusTypes.push(y.itemStatus.itemStatusType.name);
                        }
                    })
                });

                setItemStatusTypes(statusTypes)
                setTableData([...response])

            })
            .catch(e => handleException(e));
    }, [projectId])

    function submit() {
        if (tableData) {
            var selectedItems = tableData.filter(x => x['_checkbox_Select'] == true);
            if (formData && selectedItems.length > 0) {
                formData.workflowIds = selectedItems.map(x => x.id)
                setShowSpinner(true)
                DataService
                    .post<Result>(`api/v1/Workflow/StopWorkflows`, formData)
                    .then(response => {
                        setShowSpinner(false)
                        handleResult(response);
                        if (response.isSuccesful === true && onHide) {
                            onHide();
                        }
                    })
                    .catch(e => { handleException(e); setShowSpinner(false); });
            }
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'reason', label: 'Reason', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData);

    function getStatusColor(projectItemRevision: WorkflowModel, colInfo: IColInfo): string | undefined {
        if (projectItemRevision.itemRevision && projectItemRevision.itemRevision.itemStatus)
            return projectItemRevision.itemRevision.itemStatus.color;
    }

    function getStatus(projectItemRevision: WorkflowModel, colInfo: IColInfo): string | undefined {
        const status = colInfo.dataProp;
        let result = ''

        projectItemRevision.itemRevision.itemRevisionStatuses.forEach(y => {
            if (y.isLatest == true && y.itemStatus.itemStatusType.name == status) {
                result = y.itemStatus.name;
            }
        })
        return result;
    }

    function onCheckboxButtonClick(selectedRows: WorkflowModel[]) {
        if (tableData) {
            const select = tableData.length !== selectedRows.length
            tableData.forEach(x => x['_checkbox_Select'] = select);
            setTableData([...tableData])
        }
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { checkboxButton: { text: "Select", icon: 'fa-check', color: 'green', onClick: onCheckboxButtonClick } },
        { getCellBackgroundColor: getStatusColor, sort: false, width: 5 },
        { title: 'Item Nr', dataProp: 'itemRevision.item', dataType: 'item', sort: 'asc' },
        { title: 'Revision', dataProp: 'itemRevision.revisionNumber', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Workflow', dataProp: 'workflowDefinition.name' },
        { title: 'Workflow status', dataProp: 'workflowStatus' },
        { title: 'Design phase', dataProp: 'itemRevision.designPhase' },
    ];

    if (itemStatusTypes) {
        itemStatusTypes.forEach((value, index) => {
            colInfos.push({ title: value, dataProp: value, getCellData: getStatus });
        });
    }

    return <>
        <Popup show={show} onHide={onHide} size={'xl'} title={'Stop project-item workflows'} >
            <Popup.Body>
                <TextboxField {...getFieldProps('reason')} />
                <div style={{ marginTop: 24 }}>
                    <DataTable
                        name='dtProjectItemsStopableWorkflows'
                        colInfos={colInfos}
                        tableData={tableData}
                    />
                </div>
            </Popup.Body>
            <Popup.Footer>
                <Button {...getSubmitButtonProps()} text='Stop workflows' fill />
            </Popup.Footer>
        </Popup>
        { showSpinner && <SpinnerOverlay /> }
    </>
}
export default StopItemWorkflowsPopup;